<app-floating-button
  [cmpModal]="MobileSearchModalComponent"
  [isActiveFilter]="!!(repository.searchPhrase$ | async)?.length"
></app-floating-button>

<app-breadcrumb
  [items]="breadcrumbs"
  [title]="DescriptionPage.Title"
  [hasFloatingButton]="true"
></app-breadcrumb>

<div class="section section-has-sider">
  <div class="section-content grid">
    <div class="section-main">
      <div
        class="hidden-xs typography typography-h4 grey-800"
        [innerHTML]="DescriptionPage.Description | safeHtml"
      ></div>

      <div class="hidden block-xs">
        <div
          appShowMore
          class="overflow-hidden typography typography-h4 grey-800"
          [innerHTML]="DescriptionPage.Description | safeHtml"
        ></div>
      </div>

      <div class="mb-48"></div>

      <nz-tabset
        (nzSelectChange)="setTab([$event])"
        [nzSelectedIndex]="tabIndex$ | async"
      >
        <nz-tab [nzTitle]="Tab.Analyzes"></nz-tab>
        <nz-tab [nzTitle]="Tab.Diseases"></nz-tab>
        <nz-tab [nzTitle]="Tab.GlossaryTerms"></nz-tab>
      </nz-tabset>

      <div
        class="grid grid-gutter-16 grid-column"
        *ngIf="!(repository.isLoadedlist$ | async)"
      >
        <div class="grid-item">
          <nz-skeleton-element
            class="typography typography-paragraph"
            style="width: 10%"
            nzType="input"
            nzSize="small"
            [nzActive]="true"
          ></nz-skeleton-element>
        </div>
        <div class="grid-item">
          <nz-skeleton
            [nzActive]="true"
            [nzTitle]="false"
            [nzParagraph]="{ rows: 4 }"
          ></nz-skeleton>
        </div>
        <div class="grid-item mt-32">
          <nz-skeleton-element
            class="typography typography-paragraph"
            style="width: 10%"
            nzType="input"
            nzSize="small"
            [nzActive]="true"
          ></nz-skeleton-element>
        </div>
        <div class="grid-item">
          <nz-skeleton
            [nzActive]="true"
            [nzTitle]="false"
            [nzParagraph]="{ rows: 4 }"
          ></nz-skeleton>
        </div>
      </div>

      <app-helix-book-list
        *ngIf="repository.isLoadedlist$ | async"
      ></app-helix-book-list>
      <app-backtop></app-backtop>
    </div>

    <div
      class="section-sider section-sider-mobile-full-screen grid-item grid-4"
    >
      <app-helix-book-search-panel
        class="affix affix-top-40"
      ></app-helix-book-search-panel>
    </div>
  </div>
</div>
